import { atom, selector } from 'recoil';
import { getConfig as hostGetConfig } from '../service/host';

export const checkoutState = atom({
  key: 'checkout',
  default: {
    config: null
  }
});

export const getConfig = selector({
  key: 'getConfig',
  get: async ({ get }) => {
    return hostGetConfig();
  }
});
